export default __webpack_public_path__ + "static/media/list.ab93b480.svg";